// ///storage constant
///const { host } = window.location
export default {
  STORAGE_URL: "https://storage.oms.innovate10x.com",
  SERVERS_URL:
    "https://ams-servers-list.activitymanagementsolution.com/ams-servers-v2",
  DEV_URL: "dev10-web.oms.innovate10x.com",
  MEDIA_PREFIX: "scanned-media-prefix",
};
